// GenreStories.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ComicList from './ComicList';
import { Container, Typography, Button, Box, IconButton } from '@mui/material';
import { useMediaQuery } from '@mui/material'; // Thêm import này

const GenreStories = ({ searchValue = '' }) => {
  const { slug } = useParams(); // Lấy slug từ URL
  const [comics, setComics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 1000; // Đặt cố định số lượng trang (ví dụ: 5 trang)

  const isMobile = useMediaQuery('(max-width: 750px)'); // Kiểm tra nếu màn hình nhỏ hơn 560px

  // Hàm gọi API
  const fetchComics = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(`https://otruyenapi.com/v1/api/the-loai/${slug}?page=${page}`);
      const { items } = response.data.data; // Lấy danh sách items

      // Cập nhật danh sách comics
      setComics(items);
    } catch (error) {
      console.error('Error fetching the comic list:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchComics(currentPage);
  }, [currentPage, slug]);

  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, startPage + 4);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Đảm bảo searchValue luôn là chuỗi trước khi gọi toLowerCase()
  const safeSearchValue = typeof searchValue === 'string' ? searchValue : '';

  return (
    <Container className="app-container">
      <Typography variant={isMobile ? 'h5' : 'h4'} component="h1" gutterBottom>
        Thể loại: {slug} - Trang {currentPage}
      </Typography>
      <hr style={{ margin: '20px 0', border: '1px solid #ccc' }} />
      {loading ? (
        <p>Đang tải dữ liệu...</p>
      ) : (
        <ComicList 
          comics={comics.filter(comic => {
            const comicName = typeof comic.name === 'string' ? comic.name.toLowerCase() : '';
            const search = safeSearchValue.toLowerCase();
            return comicName.includes(search);
          })}
        />
      )}
      <Box mt={2} display="flex" justifyContent="center" alignItems="center">
        {getPageNumbers().map((number) => (
          <Button 
            key={number} 
            variant="outlined" 
            onClick={() => handlePageChange(number)} 
            style={{ margin: '0 5px' }}
          >
            {number}
          </Button>
        ))}

      </Box>
    </Container>
  );
};

export default GenreStories;
